// Referenced from ../../Router/pages/ShowingsCalendarPage/constants.ts
export const ES_DELAY = 5500;
